import React from 'react';

import { AnimatePresence } from 'framer-motion';

import { StyledLoader } from './styles';

const animation = {
    animate: {
        rotate: [0, 10, -10, 0],
        transition: { duration: 1.6, ease: [0.6, 0, 0.2, 1], repeat: Infinity },
    },
};

interface Props {
    className?: string;
    show?: boolean;
    disableLoadingAnimation?: boolean;
}

const YatLoader = ({ className, show, disableLoadingAnimation }: Props) => {
    return (
        <AnimatePresence>
            {show && (
                <StyledLoader
                    className={className}
                    variants={animation}
                    animate={disableLoadingAnimation ? undefined : 'animate'}
                />
            )}
        </AnimatePresence>
    );
};

export default YatLoader;
